export const AppointmentErrorMessages = {
  APPOINTMENT_TIME_CONFLICT: {
    title: 'קיים תור באותה שעה',
    message: 'כבר קיים תור מתוזמן בשעה זו. אם אינך רואה אותו, מומלץ להתנתק ולהתחבר מחדש.'
  },
  APPOINTMENT_RECURRING_TIME_CONFLICT: {
    title: 'התנגשות בתור חוזר',
    message: 'לא ניתן ליצור את סדרת התורים החוזרים בגלל התנגשות עם תור קיים.'
  },
  APPOINTMENT_MISSING_DATA: {
    title: 'חסרים פרטים',
    message: 'יש להזין את כל הפרטים הנדרשים ליצירת תור.'
  },
  APPOINTMENT_INVALID_CUSTOMER: {
    title: 'לקוח לא תקין',
    message: 'יש לבחור לקוח מהרשימה.'
  },
  APPOINTMENT_INVALID_SERVICE: {
    title: 'שירות לא תקין',
    message: 'יש לבחור שירות מהרשימה.'
  },
  APPOINTMENT_INVALID_CREW_MEMBER: {
    title: 'איש צוות לא תקין',
    message: 'יש לבחור איש צוות מהרשימה.'
  },
  APPOINTMENT_INVALID_RECURRING_PATTERN: {
    title: 'תבנית חזרה לא תקינה',
    message: 'הגדרות התור החוזר אינן תקינות.'
  },
  DEFAULT: {
    title: 'שגיאה',
    message: 'אירעה שגיאה בשמירת התור. אנא נסה שנית.'
  }
};

export function getErrorMessage(errorCode, details = {}) {
  const base = AppointmentErrorMessages[errorCode] || AppointmentErrorMessages.DEFAULT;

  // Constraint-blocked time: show the constraint reason
  if (errorCode === 'APPOINTMENT_TIME_CONFLICT' && details?.constraint?.reason) {
    return {
      title: 'זמן חסום',
      message: `לא ניתן לקבוע תור בשעה זו: ${details.constraint.reason}`
    };
  }

  // Constraint-blocked recurring time: show the constraint reason
  if (errorCode === 'APPOINTMENT_RECURRING_TIME_CONFLICT' && details?.constraint?.reason) {
    const formattedDate = details.conflictDate
      ? new Date(details.conflictDate + 'T12:00:00').toLocaleDateString('he-IL', {
          weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'
        })
      : '';
    return {
      title: 'זמן חסום',
      message: `לא ניתן ליצור את הסדרה: תאריך ${formattedDate} חסום — ${details.constraint.reason}`
    };
  }

  // Build dynamic message for recurring time conflict with date/time details
  if (errorCode === 'APPOINTMENT_RECURRING_TIME_CONFLICT' && details.conflictDate && details.conflictTime) {
    const formattedDate = new Date(details.conflictDate + 'T12:00:00').toLocaleDateString('he-IL', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
    return {
      ...base,
      message: `לא ניתן ליצור את סדרת התורים החוזרים בגלל התנגשות עם תור קיים בתאריך ${formattedDate} בשעה ${details.conflictTime}.`
    };
  }

  return base;
}